import { combineReducers } from "redux";

import { authentication } from "./authentication.reducer";
import { users } from "./user.reducer";
import { alert } from "./alert.reducer";
import { dealjackets } from "./dealjacket.reducer";
import { dl_insurances } from "./dl_insurance.reducer";
import { notes } from "./note.reducer";
import { pagetypes } from "./pagetype.reducer";
import { org } from "./org.reducer";
import { page } from "./page.reducer";
import { ingestion } from "./ingestion.reducer";
import { ops } from "./ops.reducer";

const appReducer = combineReducers({
  authentication,
  users,
  dealjackets,
  dl_insurances,
  notes,
  alert,
  pagetypes,
  org,
  page,
  ingestion,
  ops,
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
